import { BrowserRouter, Route, Routes } from 'react-router-dom'
import NotFound from './app/not-found'
import { SidebarProvider } from './components/app/SidebarContext'
import { ROUTES } from './lib/routes'
import Layout from '@/app/(pages)/Layout'
import HomePage from '@/app/(pages)/landingPage/Page'
import ContactUsPage from '@/app/(pages)/contactUs/Page'
import PrivacyPolicyPage from '@/app/(pages)/privacyPolicy/Page'
import TermsConditionsPage from '@/app/(pages)/termsConditions/Page'
import ProductsPage from '@/app/(pages)/products/Page'
import ProductDetailPage from '@/app/(pages)/products/[id]/Page'
import CartPage from '@/app/(pages)/cart/Page'
import PaymentSuccessPage from '@/app/(pages)/payment-success/Page'
import { AppProvider } from './context/AppContext'

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <AppProvider>
      <SidebarProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path={ROUTES.HOME} element={<HomePage />} />
              <Route path={ROUTES.CONTACT_US} element={<ContactUsPage />} />
              <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
              <Route path={ROUTES.TERMS_CONDITIONS} element={<TermsConditionsPage />} />
              <Route path={ROUTES.PRODUCTS} element={<ProductsPage />} />
              <Route path={ROUTES.PRODUCT_DETAIL} element={<ProductDetailPage />} />
              <Route path={ROUTES.CART} element={<CartPage />} />
              <Route path={ROUTES.PAYMENT_SUCCESS} element={<PaymentSuccessPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SidebarProvider>
    </AppProvider>
  )
}
